if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');

        if (this.prevButton) this.prevButton.addEventListener('click', () => this.navigate(-1));
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.navigate(1));

        // Swipe support — only treat fast, mostly-horizontal single-finger flicks as swipes
        // so panning or pinch-zooming a zoomed image doesn't accidentally navigate
        let touchStartX = 0;
        let touchStartY = 0;
        let touchStartTime = 0;
        let touchStartCount = 0;
        const content = this.querySelector('[role="document"]');
        if (content) {
          content.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            touchStartTime = Date.now();
            touchStartCount = e.touches.length;
          }, { passive: true });
          content.addEventListener('touchend', (e) => {
            if (touchStartCount > 1) return;
            const dx = touchStartX - e.changedTouches[0].clientX;
            const dy = touchStartY - e.changedTouches[0].clientY;
            const duration = Date.now() - touchStartTime;
            const isHorizontal = Math.abs(dx) > Math.abs(dy) * 2;
            const isFlick = duration < 500;
            if (Math.abs(dx) > 50 && isHorizontal && isFlick) {
              this.navigate(dx > 0 ? 1 : -1);
            }
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      navigate(direction) {
        const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeIndex = mediaItems.findIndex((el) => el.classList.contains('active'));
        const nextIndex = activeIndex + direction;
        if (nextIndex < 0 || nextIndex >= mediaItems.length) return;

        mediaItems.forEach((el) => el.classList.remove('active'));
        mediaItems[nextIndex].classList.add('active');
        mediaItems[nextIndex].scrollIntoView();

        if (this.prevButton) this.prevButton.style.visibility = nextIndex === 0 ? 'hidden' : 'visible';
        if (this.nextButton) this.nextButton.style.visibility = nextIndex === mediaItems.length - 1 ? 'hidden' : 'visible';
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // Update nav button visibility
        const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeIndex = mediaItems.indexOf(activeMedia);
        if (this.prevButton) this.prevButton.style.visibility = activeIndex === 0 ? 'hidden' : 'visible';
        if (this.nextButton) this.nextButton.style.visibility = activeIndex === mediaItems.length - 1 ? 'hidden' : 'visible';

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
